export const payme_initial_token = "06a750abfe2e662b4f96d90ce3c6155d"